<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <breadcrumb-component
        :moduleTitle="'Service management'"
        :mainTitle="'Server'"
        :subTitle="'Server list'"
      />
      <div class="row">
        <div class="col-md-12">
          <div class="card card_full_window vm_list_page">
            <div class="card-body">
              <div class="common_content_wrap">
                <div class="common_content_left">
                  <ServiceLeftMenuComponent />
                </div>
                <div
                  v-if="hasPagePermission('Server')"
                  class="common_content_right"
                >
                  <div class="vm_list_content">
                    <div class="d_flex_start pt_10 pb_10">
                      <div
                        class="common_dropdown dropdown_no_radius mr_10"
                        v-if="
                          customer.selected_service_id == 1 ||
                          customer.selected_service_id == 2
                        "
                      >
                        <div
                          class="btn-group dropdown-center dropdown-fill-text"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span v-if="selectedPlatform">{{
                              selectedPlatform.value
                            }}</span>
                            <span v-else>All Platform</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button
                              class="dropdown-item"
                              type="button"
                              @click.prevent="changePlatform(null)"
                            >
                              <span>All Platform</span>
                            </button>
                            <li
                              v-for="(serverPlatform, index) in serverPlatforms"
                              :key="'server_platform_' + index"
                              @click.prevent="changePlatform(serverPlatform)"
                            >
                              <button class="dropdown-item" type="button">
                                <span>{{ serverPlatform.value }}</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="common_dropdown dropdown_no_radius">
                        <div
                          class="btn-group dropdown-center dropdown-fill-text"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span v-if="selectedRegion">{{
                              selectedRegion.name
                            }}</span>
                            <span v-else>All Region</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button
                              class="dropdown-item"
                              type="button"
                              @click.prevent="changeRegion(null)"
                            >
                              <span>All Region</span>
                            </button>
                            <li
                              v-for="(serverRegion, index) in serverRegions"
                              :key="'server_region_' + index"
                              @click.prevent="changeRegion(serverRegion)"
                            >
                              <button class="dropdown-item" type="button">
                                <span>{{ serverRegion.name }}</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_10 pb_10">
                      <router-link
                        v-if="
                          hasPermission('Create') &&
                          customer.selected_service_id &&
                          customer.selected_service_id != 1
                        "
                        :to="{ name: 'create_cloud_server' }"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-primary btn-sm mr_15 width_100p"
                        >
                          VM Create
                        </button>
                      </router-link>
                      <button
                        v-if="hasPermission('Start')"
                        type="button"
                        class="btn btn-outline-success btn-sm mr_15 width_100p"
                        @click.prevent="updateTheService('start')"
                        :disabled="!canStart"
                      >
                        Start
                      </button>
                      <button
                        v-if="hasPermission('Stop')"
                        type="button"
                        class="btn btn-outline-danger btn-sm mr_15 width_100p"
                        @click.prevent="updateTheService('stop')"
                        :disabled="!canStop"
                      >
                        Stop
                      </button>
                      <button
                        v-if="hasPermission('Restart')"
                        type="button"
                        class="btn btn-outline-warning btn-sm mr_15 width_100p"
                        @click.prevent="updateTheService('restart')"
                        :disabled="!canRestart"
                      >
                        Restart
                      </button>

                      <button
                        v-if="hasPermission('Delete')"
                        type="button"
                        class="btn btn-outline-danger btn-sm width_100p"
                        @click.prevent="deleteTheRecord()"
                        :disabled="!canDelete"
                      >
                        Delete
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm ml_15 width_100p"
                        @click.prevent="loadData()"
                      >
                        Refresh
                      </button>
                    </div>
                    <cloud-table-component
                      :columns="columns"
                      :rows="cloudServers"
                      :sortable="sortable"
                      :pagination="pagination"
                      @sorting="sorting"
                      @pageChanged="pageChanged"
                    >
                      <template v-slot:id="{ row }">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'action_' + row.id"
                            @focus="checkSingleServer(row, $event)"
                            :checked="selectedServer?.id === row.id"
                          />
                          <label
                            class="form-check-label"
                            :for="'action_' + row.id"
                          ></label>
                        </div>
                      </template>

                      <template v-slot:status="{ row }">
                        <span
                          v-if="row.status == 'processing'"
                          class="color_warning"
                          >Processing</span
                        >
                        <span
                          v-if="row.status == 'running'"
                          class="color_success"
                          >Running</span
                        >
                        <span
                          v-if="row.status == 'stopped'"
                          class="color_danger"
                          >Stopped</span
                        >
                      </template>

                      <template v-slot:kt_platform="{ row }">
                        <span
                          v-if="row.kt_platform == 'g'"
                          class="color_success"
                          >G</span
                        >
                        <span
                          v-if="row.kt_platform == 'd'"
                          class="color_warning"
                          >D</span
                        >
                      </template>

                      <template v-slot:specification="{ row }">
                        <span v-if="row.kt_platform == 'g'">{{
                          row?.serverProductType?.service_offering_desc
                        }}</span>
                        <span v-if="row.kt_platform == 'd'">{{
                          row?.serverDProductType?.name
                        }}</span>
                        <span v-if="!row.kt_platform">{{
                          row?.serverProductType?.service_offering_desc
                        }}</span>
                      </template>

                      <template v-slot:os_desc="{ row }">
                        <span v-if="row.kt_platform == 'd'">{{
                          row?.serverDProductType?.catChildList?.display_name
                        }}</span>
                        <span v-else>{{
                          row?.serverProductType?.template_desc
                        }}</span>
                      </template>

                      <template v-slot:action="{ row }">
                        <button
                          v-if="hasPermission('View')"
                          type="button"
                          class="btn btn-outline-primary btn-sm mr_15 width_100p"
                          @click.prevent="openModal(row)"
                        >
                          Details
                        </button>
                      </template>
                    </cloud-table-component>
                  </div>
                </div>
                <div v-else class="common_content_right">
                  <p>You do not have permission to view this content.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DetailsModal
        v-if="isShowModal"
        :isShowModal="isShowModal"
        :modalData="modalData"
        @closeModal="closeModal"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { checkPermission } from '@/mixins/permissionsHelper';
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import ServiceLeftMenuComponent from '../ServiceLeftMenuComponent.vue';
import CloudTableComponent from '@/components/shared/CloudTableComponent.vue';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import DetailsModal from './DetailsModal.vue';
import { echo } from '@/services/echo';

export default {
  name: 'cloud-servers',
  components: {
    LoaderMaskComponent,
    ServiceLeftMenuComponent,
    CloudTableComponent,
    BreadcrumbComponent,
    DetailsModal,
  },
  data() {
    return {
      lyLoading: false,
      selectedPlatform: null,
      serverRegions: [],
      cloudServers: [],
      selectedRegion: null,
      filter: {
        kt_platform: '',
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns:
          'cloudService.name,server_name,status,serverRegion.name,serverProductType.template_desc,serverProductType.service_offering_desc,serverProductType.disk_offering_desc,private_ip,billing_type',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10,
      },
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: '',
          field: 'id',
          sortable: false,
          slot: true,
        },
        {
          label: 'Service',
          field: 'cloudService.name',
          sortable: true,
        },
        {
          label: 'Server name',
          field: 'server_name',
          sortable: true,
        },
        {
          label: 'Status',
          field: 'status',
          sortable: true,
          slot: true,
        },
        {
          label: 'Region',
          field: 'serverRegion.name',
          sortable: true,
        },
        {
          label: 'OS',
          field: 'os_desc',
          sortable: false,
          slot: true,
        },
        {
          label: 'Specification',
          field: 'specification',
          sortable: false,
          slot: true,
        },
        // {
        //     label: "Space",
        //     field: "serverProductType.disk_offering_desc",
        //     sortable: true,
        // },
        // {
        //     label: "Private IP",
        //     field: "private_ip",
        //     sortable: true,
        // },
        {
          label: 'Billing type',
          field: 'billing_type',
          sortable: true,
        },
        {
          label: 'Kt platform',
          field: 'kt_platform',
          sortable: true,
          slot: true,
        },
        {
          label: 'Started at',
          field: 'started_at',
          sortable: true,
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
      update: {
        kt_platform: '',
        server_region_id: '',
      },
      pagination: null,
      selectedServer: null,
      isShowModal: false,
      modalData: null,
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams());
        this.loadData();
      }
    },
    customer() {
      this.loadServerRegions();
      this.loadData();
    },
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      permissions: 'serverPermissions/getServicePermission',
    }),
    canStart() {
      return (
        this.selectedServer &&
        this.selectedServer.status !== 'running' &&
        this.selectedServer.status !== 'processing'
      );
    },
    canStop() {
      return (
        this.selectedServer &&
        this.selectedServer.status !== 'stopped' &&
        this.selectedServer.status !== 'processing'
      );
    },
    canRestart() {
      return (
        this.selectedServer &&
        (this.selectedServer.kt_platform == 'g' ||
          this.selectedServer.proxmox_vm_id) &&
        this.selectedServer.status !== 'stopped' &&
        this.selectedServer.status !== 'processing'
      );
    },
    canDelete() {
      return (
        this.selectedServer &&
        this.selectedServer.status !== 'running' &&
        this.selectedServer.status !== 'processing'
      );
    },
    serverPlatforms() {
      if (this.customer.g_platform && this.customer.d_platform) {
        return [
          { label: 'g', value: 'G' },
          { label: 'd', value: 'D' },
        ];
      } else if (this.customer.g_platform) {
        return [{ label: 'g', value: 'G' }];
      } else if (this.customer.d_platform) {
        return [{ label: 'd', value: 'D' }];
      } else {
        return [{ label: 'g', value: 'G' }];
      }
    },
  },
  created() {
    const query = this.getAllQueryParams();
    if (query.page) {
      this.setQueryData(query);
    }
    this.loadData();
    this.loadServerRegions();
  },
  mounted() {
    if (this.$route.query.kt_platform) {
      let platform = this.serverPlatforms.filter(
        (item) => item.label == this.$route.query.kt_platform
      );
      if (platform && platform.length > 0) {
        this.selectedPlatform = platform[0];
      }
    }
    echo
      .channel(`kt_records.${this.customer.id}`)
      .listen('.kt_record.updated', () => {
        this.loadData();
        // console.log(event, 'eeeeeee')
        // if (event.deleted_at) {
        //   console.log('Record deleted:', event);
        //   const index = this.cloudServers.findIndex(r => r.id === event.id);
        //   if (index !== -1) {
        //     this.cloudServers.splice(index, 1);
        //   }
        // } else {
        //   // Don't update if we're currently editing this record
        //   // if (this.editId === event.id) return;

        //   const index = this.cloudServers.findIndex(r => r.id === event.id);
        //   if (index !== -1) {
        //     this.cloudServers[index] = { ...this.cloudServers[index], ...event };
        //   }
        // }
      });
  },
  beforeUnmount() {
    echo.leaveChannel(`kt_records.${this.customer.id}`);
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page,
      };

      this.filter = {
        kt_platform: query.kt_platform,
        server_region_id: query.server_region_id,
      };

      this.sortable = {
        order: query.sort,
        sort: query.sort_order,
      };
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc',
      };

      this.filter = {
        kt_platform: '',
        server_region_id: '',
      };

      this.queryParams = {
        page: 1,
        search: '',
        search_columns:
          'cloudService.name,server_name,status,serverRegion.name,serverProductType.template_desc,serverProductType.service_offering_desc,serverProductType.disk_offering_desc,private_ip,billing_type',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10,
      };

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.queryParams, ...this.filter },
      });
    },
    loadData() {
      this.lyLoading = true;
      this.axios
        .get('/cloud-servers', {
          params: { ...this.queryParams, ...this.filter },
        })
        .then((response) => {
          this.cloudServers = response.data.data;
          this.pagination = response.data.meta;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    loadServerRegions() {
      this.axios.get('/server-regions').then(({ data }) => {
        this.serverRegions = data.data;
        if (this.$route.query.server_region_id) {
          let region = this.serverRegions.filter(
            (item) => item.id == this.$route.query.server_region_id
          );
          if (region && region.length > 0) {
            this.selectedRegion = region[0];
          }
        }
      });
    },
    changePlatform(platform) {
      if (platform) {
        this.selectedPlatform = platform;
      } else {
        this.selectedPlatform = '';
      }

      this.queryParams.page = 1;
      this.filter.kt_platform = this.selectedPlatform
        ? this.selectedPlatform.label
        : '';
      this.changeRoute();
    },
    changeRegion(region) {
      if (region) {
        this.selectedRegion = region;
      } else {
        this.selectedRegion = '';
      }

      this.queryParams.page = 1;
      this.filter.server_region_id = this.selectedRegion
        ? this.selectedRegion.id
        : '';
      this.changeRoute();
    },
    checkSingleServer(server, event) {
      event.target.blur();
      if (this.selectedServer?.id === server.id) {
        this.selectedServer = null;
      } else {
        this.selectedServer = server;
      }
    },
    updateTheService(status) {
      if (this.selectedServer?.proxmox_vm_id) {
        this.updateProxmoxServer(status);
      } else {
        this.updateRecord(status);
      }
    },
    updateRecord(status) {
      this.$swal({
        title: 'Are you sure want to ' + status + '?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, ' + status + ' it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = {
            id: this.selectedServer.id,
            action: status,
          };
          if (this.selectedServer.kt_platform == 'g') {
            this.axios
              .post('/update-cloud-server-status', formData)
              .then((response) => {
                if (response.data.success) {
                  this.selectedServer = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true,
                  });
                }
              });
          } else {
            this.axios
              .post('/update-d-cloud-server-status', formData)
              .then((response) => {
                if (response.data.success) {
                  this.selectedServer = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true,
                  });
                }
              });
          }
        }
      });
    },
    updateProxmoxServer(status) {
      this.$swal({
        title: 'Are you sure want to ' + status + '?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, ' + status + ' it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = {
            id: this.selectedServer.id,
            action: status,
          };
          this.axios
            .put('/proxmox/update-vm-status', formData)
            .then((response) => {
              if (response.data.success) {
                this.selectedServer = null;
                this.showSuccessMsg(response.data.message);
                this.loadData();
              } else {
                this.$swal({
                  text: response.data.message,
                  showCancelButton: false,
                  confirmButtonText: 'Close!',
                  confirmButtonColor: '#dd4b39',
                  reverseButtons: true,
                });
              }
            });
        }
      });
    },
    deleteTheRecord() {
      if (this.selectedServer?.proxmox_vm_id) {
        this.deleteProxmoxVMRecord();
      } else {
        this.deleteRecord();
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete('/cloud-servers/' + this.selectedServer.id)
            .then((response) => {
              if (response.data.success) {
                this.selectedServer = null;
                this.showSuccessMsg(response.data.message);
                this.loadData();
              } else {
                this.$swal({
                  text: response.data.message,
                  showCancelButton: false,
                  confirmButtonText: 'Close!',
                  confirmButtonColor: '#dd4b39',
                  reverseButtons: true,
                });
              }
            });
        }
      });
    },
    deleteProxmoxVMRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete(`/proxmox/delete-vm/${this.selectedServer.id}`)
            .then((response) => {
              if (response.data.success) {
                this.selectedServer = null;
                this.showSuccessMsg(response.data.message);
                this.loadData();
              } else {
                this.$swal({
                  text: response.data.message,
                  showCancelButton: false,
                  confirmButtonText: 'Close!',
                  confirmButtonColor: '#dd4b39',
                  reverseButtons: true,
                });
              }
            });
        }
      });
    },
    openModal(data) {
      this.modalData = data;
      this.isShowModal = true;
    },
    closeModal() {
      this.loadData();
      this.modalData = false;
      this.isShowModal = false;
    },
    hasPermission(action) {
      let serverIndex = this.permissions?.cloud_sub_service?.indexOf('Server');
      let entity = this.permissions?.cloud_sub_service[serverIndex];
      return checkPermission(this.permissions, entity, action);
    },
    hasPagePermission(entityName) {
      return (
        this.permissions?.cloud_sub_service?.includes(entityName) ||
        this.permissions?.cloud_sub_service?.includes('All')
      );
    },
  },
};
</script>
